import Merchant from '../services/Merchant';
import { receiveApiError } from './errors';

export const LOADING_MERCHANT = 'LOADING_MERCHANT';
export const MERCHANT_SELECTED = 'MERCHANT_SELECTED';
export const UPDATE_TIME = 'UPDATE_TIME';
export const UPDATING_TIME = 'UPDATING_TIME';
export const UPDATE_TIME_FAILED = 'UPDATE_TIME_FAILED';
export const UPDATE_DELIVERY_PERSONALLY = 'UPDATE_DELIVERY_PERSONALLY';

export function updateDeliveryPersonallyType(merchant) {
  return {
    type: UPDATE_DELIVERY_PERSONALLY,
    merchant,
  };
}

export function loadingMerchant() {
  return {
    type: LOADING_MERCHANT,
  };
}

export function selectedMerchant(merchant) {
  return {
    type: MERCHANT_SELECTED,
    merchant,
  };
}

export function updatingMerchant() {
  return {
    type: UPDATING_TIME,
  };
}

export function updateTimeFailed() {
  return {
    type: UPDATE_TIME_FAILED,
  };
}

export function updateTime(merchant) {
  return {
    type: UPDATE_TIME,
    merchant,
  };
}

export function updateDeliveryPersonally(data) {
  return async (dispatch, getState) => {
    try {
      const response = Merchant.updateDeliveryPersonally(data);
      const { merchant } = getState().merchant;
      dispatch(updateDeliveryPersonallyType({ ...merchant, ...data }));
      return response;
    } catch (err) {
      dispatch(receiveApiError(err));
    }
  };
}

export function updateEstimatedTimes(data) {
  return async (dispatch, getState) => {
    dispatch(updatingMerchant());

    try {
      const response = await Merchant.updateEstimatedTimes(data);
      const { merchant } = getState().merchant;

      dispatch(updateTime({ ...merchant, ...data }));

      return response;
    } catch (error) {
      console.log('erro: ', error);
      dispatch(updateTimeFailed());

      return {
        status: 0,
        error,
      };
    }
  };
}

export function getMerchant() {
  return dispatch => {
    dispatch(loadingMerchant());
    Merchant.get()
      .then(resp => {
        dispatch(selectedMerchant(resp.data));
      })
      .catch(err => {
        dispatch(receiveApiError(err));
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/merchant.js